import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { Input } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SlidersArray from "./SliderArray";
import { useState } from "react";

const Requirements = () => {
    const { formatMessage, locale } = useIntl();
    const dispatch = useDispatch();
    const { loading, error, section } = useSelector((state) => state.section);
    const [paperSliders, setPaperSliders] = useState([])
    const [procedureSliders, setProcedureSliders] = useState([])
    const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm();

    // get single page by slug
    useEffect(() => {
        dispatch(
            getSection({
                page: "home",
                slug: "requirements",
            })
        );
    }, [dispatch]);

    useEffect(() => {
        reset({
            heading: section?.heading,
            subHeading: section?.subHeading,
            papers: section?.papers,
            procedures: section?.procedures
        });
        setPaperSliders(section?.papers?.items)
        setProcedureSliders(section?.procedures?.items)
       
    }, [reset, section]);

    // error
    useEffect(() => {
        if (error) {
            toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
        }
    }, [error, formatMessage, locale]);

    const onSubmit = (data) => {
        data.papers.items = paperSliders;
        data.procedures.items = procedureSliders;
        dispatch(
            editSection({ slug: "requirements", page: "home", data: { section: data } })
        );
    };

    if (loading) return <Loader />;

    return (
        <>
            <div className="acc-form">
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Col xl={8} md={12}>
                                <div className="border border-secondary px-5 py-4 rounded-4 mb-3">
                                    <div className="card-head">
                                        <h4>
                                            <FormattedMessage id={"mainTitle"} />
                                        </h4>
                                    </div>

                                    {/* heading  */}
                                    <Row>
                                        <Col lg={6} xs={12}>
                                            <Input
                                                langId="title"
                                                name="heading.ar"
                                                register={register}
                                                errors={errors}
                                            />
                                        </Col>
                                        <Col lg={6} xs={12}>
                                            <Input
                                                langId="title"
                                                name="heading.en"
                                                register={register}
                                                errors={errors}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} xs={12}>
                                            <Input
                                                langId="description"
                                                name="subHeading.ar"
                                                register={register}
                                                errors={errors}
                                            />
                                        </Col>
                                        <Col lg={6} xs={12}>
                                            <Input
                                                langId="description"
                                                name="subHeading.en"
                                                register={register}
                                                errors={errors}
                                            />
                                        </Col>
                                    </Row>
                                </div>

                                <div className="border border-secondary px-5 py-4 rounded-4 mb-3">

                                    <h3 className="text-white mb-3">
                                        <FormattedMessage id={"papers"} />
                                    </h3>

                                    <Row>
                                        <Row>
                                            <Col lg={6} xs={12}>
                                                <Input
                                                    langId="title"
                                                    name="papers.title.ar"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </Col>
                                            <Col lg={6} xs={12}>
                                                <Input
                                                    langId="title"
                                                    name="papers.title.en"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg={6} xs={12}>
                                                <Input
                                                    langId="description"
                                                    name="papers.description.ar"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </Col>
                                            <Col lg={6} xs={12}>
                                                <Input
                                                    langId="description"
                                                    name="papers.description.en"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </Col>
                                        </Row>
                                        <SlidersArray setSliders={setPaperSliders} sliders={paperSliders} text={"addPaper"} />
                                    </Row>
                                </div>

                                <div className="border border-secondary px-5 py-4 rounded-4 mb-3">
                                    <h3 className="text-white mb-3">
                                        <FormattedMessage id={"procedures"} />
                                    </h3>

                                    <Row>
                                        <Row>
                                            <Col lg={6} xs={12}>
                                                <Input
                                                    langId="title"
                                                    name="procedures.title.ar"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </Col>
                                            <Col lg={6} xs={12}>
                                                <Input
                                                    langId="title"
                                                    name="procedures.title.en"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg={6} xs={12}>
                                                <Input
                                                    langId="description"
                                                    name="procedures.description.ar"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </Col>
                                            <Col lg={6} xs={12}>
                                                <Input
                                                    langId="description"
                                                    name="procedures.description.en"
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </Col>
                                        </Row>
                                        <SlidersArray setSliders={setProcedureSliders} sliders={procedureSliders} text={"addProcedure"} />
                                    </Row>
                                </div>

                                <SaveChangesButton />
                            </Col>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Requirements;
